<template>
  <b-form-group class="form-group-checkbox" :style="`margin-bottom:${bottom}px`">
    <b-form-checkbox
      switch
      size="lg"
      :id="'checkbox__' + formGroupId"
      v-model="text"
      :name="'checkbox__' + formGroupId"
      :required="required"
      class="checkbox"
      :disabled="disabled || viewMode"
      :style="`padding-left:${left}px`"
      @change="updateValue"
    >
      <span>{{ placeholder | i18n }}</span>
    </b-form-checkbox>
    <b-form-text v-if="bottomText">
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
export default {
  name: 'Trigger',
  props: {
    bottomText: {
      type: String,
      default: '',
    },
    formGroupId: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Number,
      default: 0,
    },
    bottom: {
      type: Number,
      default: 35,
    },
    input: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      text: null,
    };
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    },
  },
  mounted() {
    this.text = this.value;
  },
  methods: {
    updateValue(value) {
      if (this.input) {
        this.input(value);
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  label {
    margin-bottom: 0 !important;
    padding-left: 26px;
    display: flex;
    align-items: center;
  }

  &.custom-switch .custom-control-label span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding-top: 5px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #646a87;
  }
  &.custom-switch .custom-control-label {
    padding-left: 0px;
  }
}
::v-deep .checkbox.custom-control .custom-control-input:checked ~ .custom-control-label::before {
  background: #2260ff !important;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: transparent;
  background: #c5d0de;
}

.custom-switch .custom-control-label::before {
  border-color: transparent;
  background: #c5d0de;
}

.custom-switch.b-custom-control-lg .custom-control-label::after,
.input-group-lg .custom-switch .custom-control-label::after {
  background: #ffffff;
}
</style>
